// import { getToken, getUser } from "../../../Helpers/Utils/Common";
import { getToken, getUser } from "../../Utilities/Common";
import {
  getWithParamsAPICall,
  postAPICall,
  postAPICallwithFile,
} from "../axiosMethodCall";

//POST API -- append a new data to the db
export const createLaboratory = async (info, is_lab_dependent) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());
    formData.append("lab", info.lab ? info.lab : "");
    formData.append("test", info.test ? info.test : "");
    formData.append("unit", info.unit ? info.unit : "");
    formData.append("type", info.type ? info.type : "");
    formData.append("is_lab_dependent", is_lab_dependent);
    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "lab_tests/create",
      formData
    );
    return response;
  } catch (error) {
    return { error: error.response };
  }
};

export const getLabTests = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "lab_tests/get_by_lab",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getAllLabResults = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      branch_id: data.branch_id || "",
      ...data,
    };
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "lab_results/get_all_results",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getLabTestResult = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      branch_id: data.branch_id || "",
      ...data,
    };
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "lab_results/get_lab_test_result",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};


export const updateLaboratory = async (info) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());
    formData.append("lab_test_id", info.id);
    formData.append("lab", info.lab ? info.lab : "");
    formData.append("test", info.test ? info.test : "");
    formData.append("unit", info.unit ? info.unit : "");
    formData.append("type", info.type ? info.type : "");
    // formData.append("type", info.type ? info.type : "");

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "lab_tests/update",
      formData
    );

    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const deleteLaboratory = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "lab_tests/delete",
      {
        requester: getUser(),
        token: getToken(),
        lab_test_id: id,
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const createMultipleLabs = async (data) => {
  try {

    const API = 'lab_results/create_multiple';
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());

    // Once lang — no brackets
    formData.append("patient_id", data.patient_id);
    formData.append("lab_test_type", data.types);
    formData.append("lab_test_id", data.lab_test_id || "");
    formData.append("lab_result_id", data.lab_result_id || "");
    formData.append("result_date", data.selectedDate || "");
    formData.append("lab_test_name", data.lab_test_name || "");
    formData.append("doctor_id", data.doctor_id || "");
    formData.append("performed_by", data.performed_by || "");
    formData.append("reference_facility", data.facility || "");
    
    formData.append("attachments[]", data.attachments || "");

    // for non YAKAP LAB TEST
    if (data.filteredDetails.length === 1 && !data.is_phic_yakap) {
      formData.append("over_all_result", data.filteredDetails[0].result || "");
    }

    // Per analyte — with brackets (category labs only)
    if (data.types === "others") { // FOR OTHERS TAB
      formData.append("result", data.result || "");
    } else {
      data.filteredDetails.forEach((lab) => { // FOR NON OTHERS TAB
        formData.append("lab_test_breakdown_id[]", lab.lab_test_breakdown_id || ""); // lab_test_breakdown id
        formData.append("analyte[]", lab.key || ""); // save the unique key for easier data autofill later on
        formData.append("result[]", lab.option_id ? lab.option_id : lab.result || "");
      });
    }

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + API,
      formData,
      true
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const updateLabResult = async (data, doctorId) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());
    formData.append("lab_result_id", data.id);
    formData.append("lab_test_id[]", data.lab_test_id);
    formData.append("patient_id", data.patient_id);
    formData.append("result", data.result || "");
    formData.append("result_date", data.result_date || null);
    // formData.append("attachments[]", data?.attachments || null);
    // formData.append("attachment_ids[]", data?.attachments?.id || null);
    if (data?.attachments?.id) {
      formData.append("attachment_ids[]", data.attachments.id);
    } else if (data?.attachments) {
      formData.append("attachments[]", data.attachments);
    }
    formData.append("lab_test_name[]", data.lab_test_name || null);
    formData.append("types[]", data.lab_type_name);
    formData.append("doctor_id[]", doctorId || '');

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "lab_results/update",
      formData,
      true
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const deleteLabResult = async (lab_result_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "lab_results/delete",
      {
        requester: getUser(),
        token: getToken(),
        lab_result_id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getLabResults = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "lab_results/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
